import React, { useEffect, useState } from "react";
import ComicModel from "../../models/ComicModel";
import { LoadingSpinner } from "../utils/LoadingSpinner";
import { SearchComic } from "./SearchComic/SearchComic";
import { Pagination } from "../utils/Pagination";
import { config } from './../../Constants'

export const SearchComicPage = () => {
	const [comics, setComics] = useState<ComicModel[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [httpError, setHttpError] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [comicsPerPage] = useState(5);
	const [totalAmountOfComics, setTotalAmountOfComics] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [search, setSearch] = useState("");
	const [searchUrl, setSearchUrl] = useState("");

	const [category, setCategory] = useState('All');

	const standardUrl: string = `?page=${currentPage - 1}&size=${comicsPerPage}`

	const API_BASE_URL = config.url.API_HOST

	useEffect(() => {
		const fetchComic = async () => {
			const baseUrl: string = `${API_BASE_URL}/api/comics`;
			console.log(baseUrl)

			let url: string = "";

			if (searchUrl === "" && category === 'All') {
				console.log("Empty Search and Category All")
				url = `${baseUrl + standardUrl}`;
			} else {
				url = `${baseUrl + searchUrl}`;
			} 
	
			const response = await fetch(url);


			if (!response.ok) {
				console.log("ERROR");
				throw new Error("Something went wrong!");
			}

			const responseJson = await response.json();

			const responseData = responseJson._embedded.comics;

			setTotalAmountOfComics(responseJson.page.totalElements);
			setTotalPages(responseJson.page.totalPages);

			const loadedComics: ComicModel[] = [];

			responseData.map((item: ComicModel) => {
				loadedComics.push(item);
			});

			setComics(loadedComics);
			setIsLoading(false);
		};

		fetchComic().catch((error: any) => {
			setIsLoading(false);
			setHttpError(error.message);
		});
		window.scrollTo(0, 0);
	}, [currentPage, searchUrl]);

	if (isLoading) {
		return <LoadingSpinner></LoadingSpinner>;
	}

	if (httpError) {
		return (
			<div className="container m-5">
				<p>{httpError}</p>
			</div>
		);
	}

	const indexOfLastComic: number = currentPage * comicsPerPage;
	const indexOfFirstComic: number = indexOfLastComic - comicsPerPage;
	let lastItem =
		comicsPerPage * currentPage <= totalAmountOfComics
			? comicsPerPage * currentPage
			: totalAmountOfComics;

	const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

	const searchHandleChange = () => {
		setCurrentPage(1)
		if (search === "") {
			if (category === 'All') {
				setSearchUrl("");
			} else {
				setSearchUrl(
					`/search/findByTitleContainingAndCategory?title=${search}&category=${category}&page=0&size=${comicsPerPage}`
				);
			}
	
		} else {
			if (category === 'All') {
				setSearchUrl(
					`/search/findByTitleContaining?title=${search}&page=0&size=${comicsPerPage}`
				);
			} else {
				setSearchUrl(
					`/search/findByTitleContainingAndCategory?title=${search}&category=${category}&page=0&size=${comicsPerPage}`
				);
			}

		}
	};

	const categoryField = async(value: string) => {
		setCurrentPage(1)
		if (value.toLocaleLowerCase() === 'physical' || value.toLocaleLowerCase() === 'virtual') {
			setCategory(value)
			if (search === "") {
				setSearchUrl(
					`/search/findByCategory?category=${value}&page=0&size=${comicsPerPage}`
				);
			} else {
				setSearchUrl(
					`/search/findByTitleContainingAndCategory?title=${search}&category=${value}&page=0&size=${comicsPerPage}`
				);
			}
		} else {
			setCategory('All')
			if (search === "") {
				setSearchUrl(
					standardUrl
				);
			} else {
				setSearchUrl(
					`/search/findByTitleContaining?title=${search}&page=0&size=${comicsPerPage}`
				);
			}
		}

	}

	return (
		<div>
			<div className="container">
				<div>
					<div className="row mt-5">
						<div className="col-6">
							<div className="d-flex">
								<input
									className="form-control me-2"
									type="search"
									placeholder="Search"
									aria-labelledby="Search"
									onChange={(e) => setSearch(e.target.value)}
								></input>
								<button
									onClick={searchHandleChange}
									className="btn btn-dark"
								>
									Search
								</button>
							</div>
						</div>
						<div className="col-4">
							<div className="dropdown">
								<button
									className="btn btn-dark dropdown-toggle"
									type="button"
									id="dropdownMenuButton1"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									{category}
								</button>
								<ul
									className="dropdown-menu"
									aria-labelledby="dropdownMenuButton1"
								>
									<li>
										<a onClick={() => categoryField('All')} className="dropdown-item" href="#">
											All
										</a>
									</li>
									<li>
										<a onClick={() => categoryField('Physical')} className="dropdown-item" href="#">
											Physical
										</a>
									</li>
									<li>
										<a onClick={() => categoryField('Virtual')} className="dropdown-item" href="#">
											Virtual
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>

					{totalAmountOfComics > 0 ? (
						<div>
							{" "}
							<div className="mt-3">
								<h5>Search Results: ({totalAmountOfComics})</h5>
							</div>
							<p>
								Page #{currentPage} - Showing{" "}
								{totalAmountOfComics === 0
									? 0
									: indexOfFirstComic + 1}{" "}
								to {lastItem} from {totalAmountOfComics} items:
							</p>{" "}
						</div>
					) : (
						<div className="m-5">
							{" "}
							<h3>
								No comics founds with that search query.
							</h3>{" "}
						</div>
					)}

					{comics.map((comic) => (
						<SearchComic comic={comic} key={comic.id}></SearchComic>
					))}
					{totalPages > 1 && (
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							paginate={paginate}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
